'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _productLabelUpload = require('./product-label-upload.component');

var _productLabelUpload2 = _interopRequireDefault(_productLabelUpload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.components.productLabelUpload', []).component('productLabelUpload', _productLabelUpload2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/product-label-upload/product-label-upload.module.js